import { types, type Instance } from 'mobx-state-tree';
import { SalaryType } from 'src/App/AppPageBlock/graphql/cm-types.generated';
export const EducationCompletionDate = types.model('EducationCompletionDate', {
  year: types.integer,
  month: types.maybeNull(types.integer),
});

export const ProfileTextObject = types.model('NameObject', {
  text: types.string,
});

export const CredentialInfo = types.model('CredentialMetaData', {
  name: types.string,
  values: types.array(types.string),
});

export const BaseCredential = types.model('BaseCredential', {
  credentialInfo: types.array(CredentialInfo),
});
export const Education = types.model('Education', {
  id: types.string,
  name: ProfileTextObject,
  completed: types.boolean,
  completionDate: types.maybeNull(EducationCompletionDate),
  highlights: types.maybeNull(types.string),
  institute: ProfileTextObject,
  credential: types.maybeNull(BaseCredential),
});

export interface IEducation extends Instance<typeof Education> {}

export const Skill = types.model('Skill', {
  keyword: ProfileTextObject,
});

export interface ISkill extends Instance<typeof Skill> {}

export const MonthYear = types.model('MonthYear', {
  month: types.integer,
  year: types.integer,
});

export const Licence = types.model('Licence', {
  id: types.string,
  description: types.maybeNull(types.string),
  expiryDate: types.maybeNull(MonthYear),
  issueDate: types.maybeNull(MonthYear),
  issuingOrganisation: types.maybeNull(types.string),
  name: ProfileTextObject,
  noExpiryDate: types.boolean,
  formattedExpiryDate: types.maybeNull(types.string),
  credential: types.maybeNull(BaseCredential),
});

export interface ILicence extends Instance<typeof Licence> {}

export const WorkHistory = types.model('WorkHistory', {
  id: types.string,
  title: ProfileTextObject,
  company: ProfileTextObject,
  startDate: MonthYear,
  endDate: types.maybeNull(MonthYear),
  achievements: types.maybeNull(types.string),
});

export interface IWorkHistory extends Instance<typeof WorkHistory> {}

export const RightToWork = types.model('RightToWork', {
  answer: types.string,
  country: types.string,
});

export const RightToWorkV2 = types.model('RightToWorkV2', {
  displayLabel: types.string,
  id: types.string,
});

export const ExpectedSalary = types.model('ExpectedSalary', {
  salaryType: types.maybeNull(
    types.enumeration<SalaryType>('SalaryType', Object.values(SalaryType)),
  ),
  minimumSalaryValue: types.maybeNull(types.number),
  maximumSalaryValue: types.maybeNull(types.number),
  currency: types.maybeNull(types.string),
});

export const Nationality = types.model('Nationality', {
  countryName: types.string,
  id: types.string,
});

const ProfileStore = types.model('ProfileStore', {
  education: types.array(Education),
  licences: types.array(Licence),
  skills: types.array(Skill),
  workHistory: types.array(WorkHistory),
  rightsToWork: types.array(RightToWork),
  expectedSalaries: types.array(ExpectedSalary),
  verifiedIdentity: types.maybeNull(
    types.model('VerifiedIdentity', {
      fullName: types.string,
    }),
  ),
  homeLocation: types.maybeNull(
    types.model('CM_Location', {
      id: types.string,
      description: types.string,
    }),
  ),
  nationality: types.array(Nationality),
  rightsToWorkV2: types.array(RightToWorkV2),
});
export interface IProfileStore extends Instance<typeof ProfileStore> {}

export default ProfileStore;
